import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import AboutDetail from "../components/AboutDetail";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const AboutUsPage = () => {
  return (
    <>
    <Helmet>
        <title>About Us | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Discover TimeWatch Infocom, a leading security technology provider in Delhi specializing in biometric solutions, advanced access control systems, entrance automation, and parking management. With a strong focus on innovation and customer satisfaction, we offer tailored security solutions for businesses and organizations across various industries. Our expertise in smart technology integration and commitment to delivering reliable and efficient services make us a trusted name in the security domain. Learn more about our journey, values, and the advanced solutions we bring to modern security challenges."
        />
        <link rel="canonical" href="https://www.timewatchindia.com/about-us" />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="about">
          <AboutDetail />
        </section>
        
      </div>

      <footer className="footer">
        <Footer />
      </footer>
      
    </>
  );
};

export default AboutUsPage;
